import { Component, Vue } from 'vue-property-decorator'
import Detail from './rules/detail'
import FieldMapping from './field-mapping/index'
import './index.less'
import { CodeRuleSearchDTO, CodeRuleServiceProxy, FieldMappingSearchDTO, FieldMappingServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'


const crsp = new CodeRuleServiceProxy()
const fmsp = new FieldMappingServiceProxy()

@Component({
  components: {
    Detail,
    FieldMapping
  }
})
export default class CodingRules extends Vue {

  menuList = [
    {
      name:"规则列表",
      key:"1"
    },
    {
      name:"字段映射",
      key:"2"
    }
  ]
  page = {
    current: 1,
    size: 30
  }
  menuKey = "1"
  searchKey = ""
  rulesList = []
  fieldList = []
  fieldTotal = 0
  loading = false

  created(){
    console.log('路由',this.$route);
    let routerName = this.$route.path.split('/')  
    if(routerName[routerName.length-1] == 'list') {
      this.menuKey = '1';
      this.getRulesList()
    }
    else if(routerName[routerName.length-1] == 'mapping') {
      this.menuKey = '2';
      this.getField();
    }
    
  }

  search(value){
    this.searchKey = value
    if(this.menuKey == '1'){
      this.getRulesList()
    } else {
      this.page.current = 1
      this.getField()
    }
  }

  pageSizeChange(value){
    this.page.current = value
    this.getField()
  }

  changeMenu(value){
    this.searchKey = ''
    if(value.key == '1'){
      this.getRulesList()
    } else {
      this.reloadField()
    }
    this.menuKey = value.key
  }

  reloadDetail(){
    this.getRulesList()
  }

  reloadField(){
    this.page.current = 1
    this.getField()
  }

  getRulesList(){
    this.rulesList = []
    const filter = {
      filterPlus: false,
      keyWords: this.searchKey,
      param: {},
    } as CodeRuleSearchDTO
    this.loading = true
    crsp.page(filter,1,-1).then(res =>{
      this.rulesList = res.records
      this.loading = false
    })
  }

  getField(){
    this.fieldList = []
    const filter = {
      filterPlus: false,
      keyWords: this.searchKey,
      param: {},
    } as FieldMappingSearchDTO
    this.loading = true
    fmsp.page(this.page.current,filter,this.page.size).then(res =>{
      // this.fieldList = res.records

      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }

      this.fieldList = JSON.parse(JSON.stringify(copy));

      this.fieldTotal = Number(res.total)
      this.loading = false
    })
  }

  render(){
    return(
      <div class="components-layout-demo-basic coading-rules">
        <a-layout style="height:100%">
          <a-layout-sider style='display: none;'>
            <a-menu
              style="height: 100%"
              default-selected-keys={['1']}
              onSelect={value => this.changeMenu(value)}
              mode="inline"
              theme="light"
            >
              {this.menuList.map(res =>{
                return (<a-menu-item  key={res.key}>
                  {res.name}
                </a-menu-item>)
              })}
            </a-menu>
          </a-layout-sider>
          <a-layout id="rules-table" style="background-color: #fff">
            {this.menuKey === "1" ? <Detail 
              loading={this.loading}
              searchValue={this.searchKey}
              menuKey={this.menuKey}
              data={this.rulesList}
              onSearch={value => this.search(value)}
              onReload={() => this.reloadDetail()}
            ></Detail> :
            <field-mapping 
              filters={this.page}
              menuKey={this.menuKey}
              searchValue={this.searchKey}
              total={this.fieldTotal}
              data={this.fieldList}
              loading={this.loading}
              onSearch={value => this.search(value)}
              onSizeChange={value => this.pageSizeChange(value)}
              onReload={() => this.reloadField()}
            ></field-mapping>}
          </a-layout>
        </a-layout>
      </div>
    )
  }
}